// One icon per portal section, shared by the main sidebar (ExpandedDrawer) and each section's
// empty state, so the two always match.
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import SportsHandballIcon from '@material-ui/icons/SportsHandball';
import SportsIcon from '@material-ui/icons/Sports';
import RecentActorsIcon from '@material-ui/icons/RecentActors';
import SportsKabaddiIcon from '@material-ui/icons/SportsKabaddi';
import BusinessIcon from '@material-ui/icons/Business';
import SportsVolleyballIcon from '@material-ui/icons/SportsVolleyball';
import EventIcon from '@material-ui/icons/Event';
import DescriptionIcon from '@material-ui/icons/Description';
import PhotoAlbumIcon from '@material-ui/icons/PhotoAlbum';
import NoteAddIcon from '@material-ui/icons/NoteAdd';

export const SECTION_ICONS = {
    Sponsors: MonetizationOnIcon,
    Roster: SportsHandballIcon,
    Coaches: SportsIcon,
    ExecutiveBoard: RecentActorsIcon,
    Opponents: SportsKabaddiIcon,
    Leagues: BusinessIcon,
    Seasons: SportsVolleyballIcon,
    Events: EventIcon,
    Articles: DescriptionIcon,
    Galleries: PhotoAlbumIcon,
    Custom: NoteAddIcon,
};
